import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const QUESTIONS = [
    "Si votre entreprise était un animal, ce serait lequel ? 🦁",
    "Quelle est la pire idée reçue sur votre métier ? 🤔",
    "Votre plus grande fierté professionnelle ? 🏆",
    "Le client qui vous a le plus marqué (en bien ou en mal) ? 😅",
    "Si vous aviez une baguette magique pour votre business ? 🪄",
    "Votre talent caché (hors boulot) ? 🎸",
    "Le meilleur conseil qu'on vous ait donné ? 💡",
    "Votre objectif n°1 cette année ? 🎯"
];

export default function CommercialIceBreakerPage() {
    const navigate = useNavigate();
    const [question, setQuestion] = useState(null);
    const [rolling, setRolling] = useState(false);

    const rollDice = () => {
        if (rolling) return;
        setRolling(true);
        setQuestion(null);

        // Animation effect
        let count = 0;
        const interval = setInterval(() => {
            count++;
            // Just visual glitch effect or feeling of shuffling
        }, 100);

        setTimeout(() => {
            clearInterval(interval);
            const randomQ = QUESTIONS[Math.floor(Math.random() * QUESTIONS.length)];
            setQuestion(randomQ);
            setRolling(false);
        }, 1000);
    };

    return (
        <div style={{ height: '100vh', width: '100vw', background: '#3b82f6', color: 'white', fontFamily: 'Inter, sans-serif', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>

            <div style={{ textAlign: 'center', maxWidth: 600, padding: 20 }}>
                <h1 style={{ fontSize: '2.5rem', fontWeight: 800, marginBottom: 10 }}>🧊 Ice Breaker</h1>
                <p style={{ opacity: 0.8, fontSize: '1.2rem', marginBottom: 50 }}>Détendez l'atmosphère en un clic.</p>

                <div style={{ minHeight: 200, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {rolling ? (
                        <div style={{ fontSize: '5rem', animation: 'spin 0.5s infinite linear' }}>🎲</div>
                    ) : question ? (
                        <div className="animate-pop" style={{ background: 'white', color: '#1e3a8a', padding: 40, borderRadius: 24, boxShadow: '0 20px 50px rgba(0,0,0,0.2)' }}>
                            <div style={{ fontSize: '2rem', fontWeight: 700, lineHeight: 1.4 }}>« {question} »</div>
                        </div>
                    ) : (
                        <div style={{ opacity: 0.5, fontSize: '1.5rem' }}>Lancez le dé pour commencer...</div>
                    )}
                </div>

                <button
                    onClick={rollDice}
                    style={{
                        marginTop: 60, padding: '20px 60px', borderRadius: 50, border: 'none',
                        background: 'white', color: '#2563eb', fontSize: '1.5rem', fontWeight: 800, cursor: 'pointer',
                        boxShadow: '0 10px 30px rgba(0,0,0,0.2)', transform: rolling ? 'scale(0.95)' : 'scale(1)', transition: 'all 0.2s'
                    }}
                >
                    {rolling ? '...' : question ? 'UNE AUTRE ! 🎲' : 'LANCER LE DÉ 🎲'}
                </button>
            </div>

            <button onClick={() => navigate('/commercial/launchpad')} style={{ position: 'fixed', bottom: 30, background: 'transparent', border: 'none', color: 'rgba(255,255,255,0.4)', cursor: 'pointer' }}>Retour</button>

            <style>{`
                @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
                .animate-pop { animation: popIn 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275); } 
                @keyframes popIn { from { transform: scale(0.5); opacity: 0; } to { transform: scale(1); opacity: 1; } }
            `}</style>
        </div>
    );
}
